import React, { createContext, useState, useContext, useEffect } from 'react';
import { useAuth } from './AuthContext';

const FlowContext = createContext(null);

// Custom hook for easier consumption of the FlowContext
export const useFlow = () => {
  return useContext(FlowContext);
};

export const FlowProvider = ({ children }) => {
  const { isAuthenticated, currentUser, loadingAuth } = useAuth();

  const [currentFlow, setCurrentFlow] = useState(() => {
    const storedFlow = localStorage.getItem('appFlow');

    if (storedFlow && ['offer', 'demand'].includes(storedFlow)) {
      return storedFlow;
    }

    console.log("FlowContext [INIT]: No valid storedFlow. Defaulting to null.");
    return null;
  });

  // Effect to update localStorage whenever currentFlow changes
  useEffect(() => {
    if (currentFlow && ['offer', 'demand'].includes(currentFlow)) {
      localStorage.setItem('appFlow', currentFlow);
    } else if (currentFlow === null) {
      localStorage.removeItem('appFlow');
    }
  }, [currentFlow]);

  useEffect(() => {


    if (!loadingAuth) {
      if (isAuthenticated && currentUser && currentUser.userType) {
        // If authenticated and userType exists, and it's different from currentFlow
        if (currentFlow !== currentUser.userType) {
          console.log("FlowContext [EFFECT - Auth Sync]: Detected currentUser.userType change. Updating currentFlow to:", currentUser.userType);
          setCurrentFlow(currentUser.userType);
        }
      } else if (!isAuthenticated && currentFlow !== null) {
        setCurrentFlow(null);
      } else {
      }
    } else {
    }
  }, [isAuthenticated, currentUser, loadingAuth]);


  // Function to set the application flow
  const setFlow = (flowType) => {
    console.log("FlowContext [setFlow]: function called with:", flowType);
    // Validate the flowType to ensure it's one of the expected values
    if (['offer', 'demand', null].includes(flowType)) {
      setCurrentFlow(flowType);
      console.log("FlowContext [setFlow]: setCurrentFlow to:", flowType);
    } else {
      console.warn('FlowContext [setFlow]: Invalid flow type provided:', flowType, 'Expected "offer", "demand", or null.');
    }
  };

  return (
    <FlowContext.Provider value={{ currentFlow, setFlow }}>
      {children}
    </FlowContext.Provider>
  );
};
